<div
  class="bg-[#FBFAFC] rounded-b-[30px] px-5 py-2 my-4 flex flex-row! justify-end gap-4 items-start"
>
  <span class="app-version-content font-light pt-3 mr-auto">
    v. {{ appVersion }}
  </span>
  <img src="assets/images/logo-asuit.png" alt="Logo Asuit" width="100" />
  <img src="assets/images/logo-deda.png" alt="Logo Deda Next srl" width="120" />
</div>
